import { render, staticRenderFns } from "./ListDelivery.vue?vue&type=template&id=94cf67c6&scoped=true&"
import script from "./ListDelivery.vue?vue&type=script&lang=ts&"
export * from "./ListDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./ListDelivery.vue?vue&type=style&index=0&id=94cf67c6&lang=scss&scoped=true&"
import style1 from "./ListDelivery.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cf67c6",
  null
  
)

export default component.exports